var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#325E89;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#325E89;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.1,222.6c-0.8,0-1.5-0.1-2.2-0.3l59.6-55.5l19.2,17.8c1.4,1.3,3.5,1.3,4.8,0l19.1-17.7l59.6,55.4 c-0.7,0.2-1.5,0.3-2.2,0.3H71.1z M63.6,217.5c-0.4-0.9-0.6-1.9-0.6-2.9V109.7c0-1,0.2-2.1,0.6-3l59.6,55.3L63.6,217.5z M228.9,101.7 c0.7,0,1.5,0.1,2.2,0.3l-81.1,75.1L69,102c0.7-0.2,1.4-0.3,2.1-0.3H228.9z M176.8,162.1l59.6-55.3c0.4,0.9,0.6,1.9,0.6,2.9v104.8 c0,1-0.2,2-0.6,2.9L176.8,162.1z M239.4,98.9L239.4,98.9L239.4,98.9c-2.8-2.7-6.6-4.3-10.5-4.3H71.1c-3.9,0-7.6,1.5-10.4,4.2l0,0 l0,0l0,0c-3,2.8-4.7,6.8-4.7,10.9v104.8c0,8.3,6.8,15.1,15.1,15.1h157.8c8.3,0,15.1-6.8,15.1-15.1V109.7 C244,105.7,242.4,101.8,239.4,98.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2);
export default __webpack_public_path__ + "static/media/email2.e53e59c3ee9238403791914f3d9cce97.svg";
export { ForwardRef as ReactComponent };